import styled, { css } from "styled-components";
import type { ElementStyledProps } from "../types";

export const ElementStyled = styled.div<ElementStyledProps>`
  &.elementWrapper {
    &[data-element-name="RichText"],
    .element.RichText {
      display: flex;
      justify-content: inherit;
      width: 100%;
    }
  }
  &[data-anchor-trigger] {
    cursor: ${({ $isAnchorActive, $selectedLinkType }) =>
      ($isAnchorActive && !$selectedLinkType) || $selectedLinkType !== "none"
        ? "pointer"
        : "auto"};
  }
  &.elementWrapper {
    .element.RichText {
      display: flex;
      justify-content: inherit;
    }

    ${({ $isSorting, $insertPosition }) =>
      $isSorting &&
      css`
        &::after {
          content: "";
          position: absolute;
          left: 0;
          width: 100%;
          height: 2px;
          background-color: #610cff;
          opacity: 0;
          visibility: hidden;
          transition-property: opacity, visibility;
          transition-duration: 0.2s;
          transition-timing-function: ease-in-out;
          ${$insertPosition === "before" &&
          css`
            top: -4px;
            opacity: 1;
            visibility: visible;
          `}
          ${$insertPosition === "after" &&
          css`
            bottom: -4px;
            opacity: 1;
            visibility: visible;
          `}
        }
      `}
  }
  .content {
    ${({ $horizontalAlignment }) =>
      $horizontalAlignment &&
      css`
        text-align: ${$horizontalAlignment === "end"
          ? "right"
          : $horizontalAlignment === "start"
            ? "left"
            : "center"};
      `};
  }
`;
